import * as React from 'react';

import { Button } from '../Thumbnails/Column/ButtonsPanel/styles';
import CombinePanel from '../../../containers/Editor/CombinePanel';
import Utils from '../../../utils';

const ButtonCombine = () => {
	const [isCombinePanelDisplayed, setIsCombinePanelDisplayed] = React.useState(false);

	return (
		<>
			<Button
				iconWidth="20px"
				iconHeight="20px"
				onClick={() => setIsCombinePanelDisplayed(true)}
			>
				{Utils.getSvgIcon('iconset_uprez_plus_in_circle')}
			</Button>
			<CombinePanel
				importManagerId="combine"
				isDisplayed={isCombinePanelDisplayed}
				onCancel={() => setIsCombinePanelDisplayed(false)}
			/>
		</>
	);
};

export default ButtonCombine;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonCombine/index.tsx